(function(){
  var root = document.getElementById('jclQuiz');
  if(!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var COL   = root.dataset.collection || 'todos';
  var steps = Array.prototype.slice.call(root.querySelectorAll('.jcl-step'));
  var bar   = document.getElementById('jclBar');
  var num   = document.getElementById('jclNum');
  var idx   = 0;
  var ans   = { piel:'', inquietudes:[], edad:'', experiencia:'', spf:'' };
  var cliente = { nombre:'', email:'' };
  var rutina = [];
  var extra  = null;

  var PASOS = [
    { tag:'paso-1-preparacion', nombre:'Preparación', clase:'limpiador', ico:'jcl-paso1',
      why:'Limpia sin alterar la barrera.' },
    { tag:'paso-2-tratamiento', nombre:'Tratamiento', clase:null, ico:'jcl-paso2',
      why:'El activo que trabaja tu inquietud principal.' },
    { tag:'paso-3-sellado',     nombre:'Sellado',     clase:null, ico:'jcl-paso3',
      why:'Hidrata y sella lo anterior.' },
    { tag:'paso-4-proteccion',  nombre:'Protección',  clase:null, ico:'jcl-paso4',
      why:'Sin SPF diario, el resto pierde efecto.' }
  ];

  var RX_DESMAQ = /precleanse|desmaquillante|aceite limpiador|agua micelar|bif[aá]sic/i;
  var RX_EXFOL  = /exfolia|exfoliant|peel|polish|foliant|\bpads\b|accelerator|acelerador/i;
  var RX_FUERTE = /retinol|retinal|20\s*%|glic[oó]lico|peel|accelerator|acelerador|nu-derm/i;

  function claseDe(p){
    var t = p.title + ' ' + (p.tags || []).join(' ');
    if(RX_DESMAQ.test(t)) return 'desmaquillante';
    if(RX_EXFOL.test(t))  return 'exfoliante';
    return 'limpiador';
  }

  var SVGNS = 'http://www.w3.org/2000/svg';
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function svgUse(id){
    var s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('class', 'jcl-ico');
    s.setAttribute('aria-hidden', 'true');
    var u = document.createElementNS(SVGNS, 'use');
    u.setAttribute('href', '#' + id);
    s.appendChild(u);
    return s;
  }

  function show(i){
    steps.forEach(function(s,n){ s.classList.toggle('is-active', n===i); });
    idx = i;
    bar.style.width = Math.round((i/(steps.length-1))*100) + '%';
    if(num) num.textContent = pad(i+1) + ' / ' + pad(steps.length);
    var y = root.getBoundingClientRect().top + window.pageYOffset - 24;
    if(window.pageYOffset > y) window.scrollTo({ top:y, behavior:'smooth' });
  }
  function next(){ if(idx < steps.length-1) show(idx+1); }

  root.querySelectorAll('[data-next]').forEach(function(b){ b.addEventListener('click', next); });

  root.querySelectorAll('.jcl-step[data-step="q"]').forEach(function(step){
    var key   = step.dataset.key;
    var multi = step.dataset.mode === 'multi';
    var max   = parseInt(step.dataset.max || '99', 10);
    var cont  = step.querySelector('[data-next]');

    step.querySelectorAll('.jcl-opt').forEach(function(opt){
      opt.addEventListener('click', function(){
        var v = opt.dataset.value;
        if(multi){
          var i = ans[key].indexOf(v);
          if(i > -1){ ans[key].splice(i,1); opt.classList.remove('is-on'); }
          else {
            if(ans[key].length >= max) return;
            ans[key].push(v); opt.classList.add('is-on');
          }
          step.querySelectorAll('.jcl-opt').forEach(function(o){
            var pos = ans[key].indexOf(o.dataset.value);
            var badge = o.querySelector('.jcl-opt__n');
            if(badge) badge.textContent = pos > -1 ? String(pos + 1) : '';
          });
          if(cont) cont.disabled = ans[key].length === 0;
        } else {
          ans[key] = v;
          step.querySelectorAll('.jcl-opt').forEach(function(o){ o.classList.remove('is-on'); });
          opt.classList.add('is-on');
          setTimeout(next, 240);
        }
      });
    });
  });

  var form = document.getElementById('jclForm');
  var formError = document.getElementById('jclFormError');

  form.addEventListener('submit', function(e){
    e.preventDefault();
    formError.hidden = true;

    var nombre = form.nombre.value.trim();
    var email  = form.email.value.trim();

    if(nombre.length < 2)                         return fail('Escribe tu nombre.');
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('Revisa tu correo electrónico.');
    if(!form.acepta.checked)                      return fail('Necesitamos tu autorización para continuar.');

    cliente.nombre = nombre;
    cliente.email  = email;

    show(steps.length-2);
    crearCliente();
    construirRutina();

    function fail(msg){ formError.textContent = msg; formError.hidden = false; }
  });

  function crearCliente(){
    var tags = ['quiz', ans.piel, ans.edad, 'exp-' + ans.experiencia, 'spf-' + ans.spf]
                 .concat(ans.inquietudes).filter(Boolean).join(', ');
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[first_name]', cliente.nombre);
    fd.append('contact[email]', cliente.email);
    fd.append('contact[accepts_marketing]', 'true');
    fd.append('contact[tags]', tags);
    fetch('/contact', { method:'POST', body:fd, credentials:'same-origin' }).catch(function(){});
  }

  function previewParam(){
    var m = /[?&]preview_theme_id=(\d+)/.exec(window.location.search);
    return m ? '&preview_theme_id=' + m[1] : '';
  }

  function endpoint(tags){
    return '/collections/' + COL + '/' + tags.filter(Boolean).join('+')
         + '?view=quiz-json' + previewParam();
  }

  var fallo = false;

  function traer(url){
    return fetch(url, { credentials:'same-origin' })
      .then(function(r){
        if(!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function(t){
        try { return JSON.parse(t).products || []; }
        catch(e){
          fallo = true;
          if(window.console) console.error('[quiz] respuesta no-JSON:', url, '\n', t.slice(0,200));
          return [];
        }
      })
      .catch(function(e){
        fallo = true;
        if(window.console) console.error('[quiz] fallo de red:', url, e);
        return [];
      });
  }

  function handleize(s){
    return String(s).toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g,'')
      .replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  }

  function resumen(txt, fallback){
    if(!txt) return fallback;
    var s = String(txt).replace(/\s+/g,' ').trim();
    if(!s) return fallback;
    var m = s.match(/^[^.]+\.?/);
    var out = (m ? m[0] : s).trim();
    if(out.length > 130) out = out.slice(0,127).replace(/[\s,;]+$/,'') + '…';
    return out;
  }

  function puntuar(p){
    var th = (p.tags || []).map(handleize);
    var score = 0;
    ans.inquietudes.forEach(function(q, i){
      if(th.indexOf(q) > -1) score += (i === 0 ? 7 : 5);
    });
    if(th.indexOf(ans.piel) > -1) score += 3;
    if(ans.edad === '36-45' || ans.edad === 'mas-45'){
      if(th.indexOf('anti-envejecimiento') > -1) score += 2;
    }
    if(ans.edad === 'menos-25' || ans.edad === '25-35'){
      if(th.indexOf('acne') > -1 || th.indexOf('poros') > -1) score += 1;
    }
    if(ans.experiencia === 'principiante' || ans.piel === 'piel-sensible'){
      if(RX_FUERTE.test(p.title)) score -= 4;
    }
    if(ans.experiencia === 'avanzado' && RX_FUERTE.test(p.title)) score += 1;
    if(ans.spf === 'nunca' && th.indexOf('protectores-solares') > -1) score += 2;
    return score;
  }

  function mejor(list){
    if(!list || !list.length) return null;
    return list.map(function(p){ return { p:p, s:puntuar(p) }; })
               .sort(function(a,b){ return b.s - a.s || a.p.price - b.p.price; })[0].p;
  }

  function construirRutina(){
    fallo = false;
    Promise.all(PASOS.map(function(paso){
      return traer(endpoint([paso.tag, ans.piel])).then(function(list){
        return list.length ? list : traer(endpoint([paso.tag]));
      });
    })).then(function(grupos){
      rutina = grupos.map(function(list, i){
        var paso = PASOS[i];
        var pool = list;
        if(paso.clase){
          var filtrado = list.filter(function(p){ return claseDe(p) === paso.clase; });
          if(filtrado.length) pool = filtrado;
        }
        return { paso: paso, producto: mejor(pool) };
      });

      extra = null;
      if(ans.piel !== 'piel-sensible' && ans.experiencia !== 'principiante'){
        var exfos = (grupos[0] || []).filter(function(p){ return claseDe(p) === 'exfoliante'; });
        var elegido = mejor(exfos);
        if(elegido) extra = { producto: elegido, incluir: true };
      }

      pintar();
      show(steps.length-1);
    });
  }

  function money(cents){
    return '$' + (cents/100).toLocaleString('es-CO', { maximumFractionDigits:0 });
  }

  // ---- Carrito: API oficial de Shopify, abre el drawer del tema ----
  function toGid(id){
    return 'gid://shopify/ProductVariant/' + String(id).replace(/\D/g, '');
  }

  function abrirDrawerFallback(){
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    var d = document.querySelector('cart-drawer-component') || document.querySelector('cart-drawer');
    if(d && typeof d.open === 'function'){ d.open(); return true; }
    return false;
  }

  function agregarAlCarrito(items){
    var A = window.Shopify && window.Shopify.actions;
    if(A && typeof A.updateCart === 'function' && typeof A.openCart === 'function'){
      return A.updateCart({
        lines: items.map(function(i){ return { merchandiseId: toGid(i.id), quantity: i.quantity }; })
      }).then(function(){ return A.openCart(); });
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r){ if(!r.ok) return r.text().then(function(t){ throw new Error(t); }); return r.json(); })
    .then(function(){ if(!abrirDrawerFallback()) window.location.href = '/cart'; });
  }

  // ---- Tarjeta: imagen grande arriba, datos abajo ----
  function tarjeta(numero, ico, titulo, p, why, opts){
    opts = opts || {};
    var card = document.createElement('article');
    card.className = 'jcl-card' + (opts.extra ? ' jcl-card--extra' : '');

    var fig = document.createElement('div');
    fig.className = 'jcl-card__fig';
    if(p.image){
      var im = document.createElement('img');
      im.src = p.image; im.alt = p.title; im.loading = 'lazy';
      fig.appendChild(im);
    }
    var chip = document.createElement('span');
    chip.className = 'jcl-card__chip';
    chip.appendChild(svgUse(ico));
    var cn = document.createElement('span');
    cn.textContent = numero;
    chip.appendChild(cn);
    fig.appendChild(chip);
    card.appendChild(fig);

    var body = document.createElement('div');
    body.className = 'jcl-card__body';

    var ep = document.createElement('p');
    ep.className = 'jcl-card__paso';
    ep.textContent = titulo;

    var et = document.createElement('h3');
    et.className = 'jcl-card__title';
    var a = document.createElement('a');
    a.href = p.url; a.textContent = p.title;
    et.appendChild(a);

    var ew = document.createElement('p');
    ew.className = 'jcl-card__why';
    ew.textContent = why;

    var epr = document.createElement('p');
    epr.className = 'jcl-card__price';
    epr.textContent = money(p.price);

    body.appendChild(ep); body.appendChild(et); body.appendChild(ew); body.appendChild(epr);

    if(opts.extra){
      var lab = document.createElement('label');
      lab.className = 'jcl-card__toggle';
      var chk = document.createElement('input');
      chk.type = 'checkbox'; chk.checked = true;
      var sp = document.createElement('span');
      sp.textContent = 'Incluir en el total';
      lab.appendChild(chk); lab.appendChild(sp);
      body.appendChild(lab);
      chk.addEventListener('change', function(){
        if(extra) extra.incluir = chk.checked;
        actualizarTotal();
      });
    }

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'jcl-add';
    add.textContent = 'Agregar';
    add.addEventListener('click', function(){
      var txt = add.textContent;
      add.disabled = true; add.textContent = 'Agregando…';
      agregarAlCarrito([{ id: p.variantId, quantity: 1 }])
        .then(function(){
          add.textContent = 'Agregado';
          add.classList.add('is-ok');
          setTimeout(function(){
            add.textContent = txt; add.disabled = false; add.classList.remove('is-ok');
          }, 2000);
        })
        .catch(function(){ add.textContent = txt; add.disabled = false; });
    });
    body.appendChild(add);

    card.appendChild(body);
    return card;
  }

  function actualizarTotal(){
    var total = rutina.reduce(function(a, r){ return a + (r.producto ? r.producto.price : 0); }, 0);
    if(extra && extra.incluir) total += extra.producto.price;
    document.getElementById('jclTotal').textContent = money(total);
    document.getElementById('jclAddAll').disabled = total === 0;
  }

  function pintar(){
    document.getElementById('jclSaludo').textContent = cliente.nombre + ', esta es tu rutina';

    var pieles  = { 'piel-grasa':'grasa','piel-mixta':'mixta','piel-seca':'seca','piel-sensible':'sensible' };
    var nombres = { manchas:'manchas', melasma:'melasma', acne:'acné', poros:'poros', arrugas:'arrugas',
                    flacidez:'flacidez', deshidratacion:'deshidratación', opacidad:'opacidad', rosacea:'rosácea' };
    var lista = ans.inquietudes.map(function(q){ return nombres[q] || q; });

    var txt = 'Piel ' + (pieles[ans.piel] || '');
    if(lista.length === 1)      txt += ', enfocada en ' + lista[0] + '.';
    else if(lista.length > 1)   txt += ', enfocada en ' + lista.slice(0,-1).join(', ') + ' y ' + lista.slice(-1) + '.';
    else                        txt += '.';
    if(ans.spf === 'nunca')     txt += ' Empieza por el protector solar: es el paso que más va a cambiar tus resultados.';
    else if(ans.experiencia === 'principiante') txt += ' Introduce un producto nuevo cada dos semanas para que tu piel se adapte sin irritarse.';
    document.getElementById('jclResumen').textContent = txt;

    var cont = document.getElementById('jclRutina');
    cont.innerHTML = '';

    var sinNada = rutina.every(function(r){ return !r.producto; });
    if(fallo && sinNada){
      var box = document.createElement('div');
      box.className = 'jcl-aviso';
      var t1 = document.createElement('p');
      t1.className = 'jcl-aviso__t'; t1.textContent = 'No pudimos leer el catálogo';
      var t2 = document.createElement('p');
      t2.className = 'jcl-aviso__d';
      t2.textContent = 'Hubo un problema técnico al consultar los productos. No es falta de inventario.';
      var rb = document.createElement('button');
      rb.type = 'button'; rb.className = 'jcl-btn'; rb.textContent = 'Reintentar';
      rb.addEventListener('click', function(){ show(steps.length-2); construirRutina(); });
      box.appendChild(t1); box.appendChild(t2); box.appendChild(rb);
      cont.appendChild(box);
      document.getElementById('jclTotal').textContent = money(0);
      document.getElementById('jclAddAll').disabled = true;
      return;
    }

    rutina.forEach(function(item, i){
      if(!item.producto){
        var vacio = document.createElement('article');
        vacio.className = 'jcl-card jcl-card--empty';
        var vb = document.createElement('div');
        vb.className = 'jcl-card__body';
        var p1 = document.createElement('p');
        p1.className = 'jcl-card__paso'; p1.textContent = item.paso.nombre;
        var p2 = document.createElement('p');
        p2.className = 'jcl-card__why';
        p2.textContent = 'Sin disponibilidad para tu perfil. Escríbenos y te asesoramos.';
        vb.appendChild(p1); vb.appendChild(p2);
        vacio.appendChild(vb);
        cont.appendChild(vacio);
        return;
      }
      var p = item.producto;
      cont.appendChild(tarjeta(pad(i+1), item.paso.ico, item.paso.nombre, p,
        resumen(p.paraQueSirve, item.paso.why)));
    });

    if(extra){
      cont.appendChild(tarjeta('+', 'jcl-plus', 'Complemento · 2 a 3 veces por semana', extra.producto,
        resumen(extra.producto.paraQueSirve, 'Exfolia y renueva la textura entre limpiezas.'),
        { extra:true }));
    }

    actualizarTotal();
  }

  var cartError = document.getElementById('jclCartError');
  document.getElementById('jclAddAll').addEventListener('click', function(){
    var btn = this;
    cartError.hidden = true;

    var items = rutina.filter(function(r){ return r.producto; })
                      .map(function(r){ return { id: r.producto.variantId, quantity: 1 }; });
    if(extra && extra.incluir) items.push({ id: extra.producto.variantId, quantity: 1 });
    if(!items.length) return;

    var txt = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';

    agregarAlCarrito(items)
      .then(function(){ btn.textContent = 'Agregado'; setTimeout(function(){ btn.textContent = txt; btn.disabled = false; }, 2200); })
      .catch(function(e){
        if(window.console) console.error('[quiz] carrito:', e);
        btn.disabled = false; btn.textContent = txt;
        cartError.textContent = 'No pudimos agregar la rutina. Intenta de nuevo o agrega los productos uno por uno.';
        cartError.hidden = false;
      });
  });

  document.getElementById('jclRetake').addEventListener('click', function(){
    ans = { piel:'', inquietudes:[], edad:'', experiencia:'', spf:'' };
    rutina = []; extra = null;
    root.querySelectorAll('.jcl-opt').forEach(function(o){ o.classList.remove('is-on'); });
    root.querySelectorAll('.jcl-opt__n').forEach(function(b){ b.textContent = ''; });
    root.querySelectorAll('.jcl-step[data-mode="multi"] [data-next]').forEach(function(b){ b.disabled = true; });
    form.reset();
    show(0);
  });

  show(0);
})();
